<template>
  <div>
    <div class="collaborate-cards mb-5">
      <h5 class="mb-3">Компании, с которыми можно сотрудничать</h5>
      <b-card-group class="d-flex overflowx-auto">
        <b-card
          v-for="supplier in sortedSuppliers"
          :key="supplier.id"
          class="mb-3 collab-card"
          :header-bg-variant="'light'"
          :header-text-variant="'dark'"
          :footer-bg-variant="'light'"
          :footer-class="'text-right'"
        >
          <template #header>
            <div 
              class="collab-card-header font-bold" 
              :title="supplier.company.name"
            >{{ supplier.company.name }}
              <template v-if="supplier.selected">
                <b-badge variant="success" class="fly-badge-supplyer">Выбрана</b-badge>
              </template>
            </div>
          </template>
          <div class="card-body-content overflow-card-body">
            <div class="font-bold">Представитель:</div>
            <div class="desire-small-text">
              <span class="name">{{ supplier.company_employee.lead_fio }}</span>
              <i class="fas fa-copy copy-icon" @click="copyToClipboardInTable(supplier.company_employee.lead_fio)"></i><br>
              <span v-if="supplier.company_employee.lead_phone">
                <a :href="`tel:+${supplier.company_employee.lead_phone}`">+{{ supplier.company_employee.lead_phone }}</a>
                <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(supplier.company_employee.lead_phone)"></i>
                <br>
              </span>
              <span v-if="supplier.company_employee.lead_company_phone">
                {{ supplier.company_employee.lead_company_phone }}
                <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(supplier.company_employee.lead_company_phone)"></i>
                <br>
              </span>
              <span v-if="supplier.company_employee.lead_email">
                <a :href="`mailto:${supplier.company_employee.lead_email}`">{{ supplier.company_employee.lead_email }}</a>
                <i class="fas fa-copy copy-icon" @click.stop="copyToClipboardInTable(supplier.company_employee.lead_email)"></i>
                <br>
              </span>
            </div>
            <div class="mt-3">
              <div class="font-bold">Комментарий:</div>
              <div class="desire-small-text">
                <template v-if="supplier.desire_comment">
                  <span v-html="formattedBody(supplier.desire_comment)"></span>
                </template>
                <template v-else>
                  Комментарий пока не оставлен
                </template>
              </div>
            </div>
          </div>
          <template #footer>
            <b-button 
              v-if="supplier.selected"
              size="sm"
              variant="outline-secondary"
              :disabled="saving"
              @click="collaborateWithSupplier(supplier, false)"
            >
              Отменить выбор
            </b-button>

            <b-button 
              v-if="!supplier.selected"
              size="sm"
              :variant="'secondary'"
              :disabled="saving"
              @click="collaborateWithSupplier(supplier)"
              style="text-transform: uppercase"
            >
              {{ supplier.selected ? 'Выбрана' : 'Выбрать' }}
            </b-button>
          </template>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import { API_EMAIL_TRACKING } from "@/constants";
import { tablePrepareData } from "@/mixins";

export default {
  mixins: [
    tablePrepareData
  ],
  props: {
    suppliers: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      saving: false
    }
  },
  computed: {
    sortedSuppliers() {
      // return [...this.suppliers].sort((a, b) => b.selected - a.selected);
      return [...this.suppliers];
    }
  },
  methods: {
    collaborateWithSupplier(supplier, decision = true) {
      this.saving = true;

      api.call('put', `${API_EMAIL_TRACKING}/${supplier.id}`, { selected: decision })
        .then(response => {
          this.$bvToast.toast('Метка о сотрудничестве успешно добавлена!', {
            title: 'Сохранено!',
            variant: 'success',
            solid: true
          });
          supplier.selected = decision;
        })
        .catch(error => {
          console.error('Error updating collaboration status:', error);
          this.$bvToast.toast('Не удалось обновить статус сотрудничества. Попробуйте снова.', {
            title: 'Ошибка!',
            variant: 'danger',
            solid: true
          });
        })
        .finally(result => {
          setTimeout(() => {
            this.saving = false;
          }, 500);
        })
    },
    formattedBody(text) {
      const paragraphs = text.split(/\r?\n/).filter(line => line.trim() !== '');
      return paragraphs.map(line => `<p class="mb-2">${line}</p>`).join('');
    }
  }
};
</script>

<style lang="scss" scoped>
.collaborate-cards {
  margin-top: 20px;
}

.collab-card {
  min-width: 280px;
  max-width: 400px;
}

.collab-card-header {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.collab-card .card-header {
  position: relative;
}

.fly-badge-supplyer {
  position: absolute;
  top: 15px;
  right: 20px;
}

.d-flex {
  display: flex;
  flex-wrap: nowrap;
}

.overflowx-auto {
  overflow-x: auto;
}

.card-body-content {
  max-height: 200px;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar {
    height: 13px !important;
    width: 9px !important;
    border-radius: 4px !important;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px !important;
    height: 13px !important;
    width: 9px !important;
  }      
}

.copy-icon {
  cursor: pointer;
}

.desire-small-text {
  font-size: 0.9rem;
}
</style>
